<div class="ui-g">
  <div class="ui-g-12">
    <p-table
      #dataTable
      [value]="commsEvents"
      [lazy]="false"
      selectionMode="single"
      [(selection)]="selectedItem"
      [rowsPerPageOptions]="[5, 10, 20]"
      (onRowSelect)="edit()"
      [responsive]="true"
      [paginator]="true"
      [rows]="10"
      rowHover="true"
      resizableColumns="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="commsEventCode">Event Code</th>
          <th pSortableColumn="title">Title</th>
          <th>Used In</th>
          <th pSortableColumn="mergeModelName">Merge Model</th>
          <th pSortableColumn="updated">Updated</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>
            <div pTooltip="Event Code">{{ item.commsEventCode }}</div>
          </td>
          <td>
            <div pTooltip="Title">{{ item.title }}</div>
          </td>
          <td>
            <div [pTooltip]="'Used in ' + item?.commsTemplates?.length + 'templates'">
              {{ item?.commsTemplates?.length || 0 }} templates
            </div>
          </td>
          <td>
            <div pTooltip="Merge Model">{{ item.mergeModelName }}</div>
          </td>
          <td>
            <div pTooltip="Updated">{{ item.updated | date : 'dd/MM/yy HH:mm' }}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!--
    <p-dataTabl #dataTable [value]="commsEvents" [lazy]="false"
                 selectionMode="single"
                 [(selection)]="selectedItem"
                 [rowsPerPageOptions]="[5,10,20]"
                 (onRowSelect)="edit()"
                 [responsive]="true" [paginator]="true" [rows]="10" rowHover="true" resizableColumns="true">

      <p-column field="commsEventCode" header="Event Code" [sortable]="tru" [editable]="false"
                pTooltip="Event Code">
        <ng-template pTemplate="commsEventCode" let-item="rowData">
          <div pTooltip="Event Code">{{ item.commsEventCode }}</div>
        </ng-template>
      </p-column>

      <p-column field="title" header="Title" [sortable]="tru" [editable]="false"
                pTooltip="Title">
        <ng-template pTemplate="body" let-item="rowData">
          <div pTooltip="Title">{{ item.title }}</div>
        </ng-template>
      </p-column>

      <p-column sortField="commsTemplates.length" field="item?.commsTemplates?.length" header="Used in" [sortable]="tru" [editable]="false"
                pTooltip="Used in">
        <ng-template pTemplate="body" let-item="rowData">
          <div pTooltip="Used in templates }}">{{ item?.commsTemplates?.length || 0 }} templates</div>
        </ng-template>
      </p-column>

      <p-column sortField="mergeModelName" field="mergeModel" header="MergeModel" [sortable]="tru" [editable]="false" pTooltip="test">
        <ng-template pTemplate="body" let-item="rowData">
          <div pTooltip="Merge Model">{{ item.mergeModelName }}</div>
        </ng-template>
      </p-column>

      <p-column field="updated" header="Updated" [sortable]="tru" [editable]="false" pTooltip="test">
        <ng-template pTemplate="body" let-item="rowData">
          <div pTooltip="Updated">{{ item.updated | date: "dd/MM/yy HH:mm" }}</div>
        </ng-template>
      </p-column>

    </p-dataTable>

    -->

    <div class="footerPanel ui-grid-row">
      <button
        type="button"
        class="btn-to-right"
        pButton
        icon="fa ui-icon-plus"
        (click)="add()"
        label="Add"
      ></button>

      <button
        type="button"
        class="btn-to-right"
        (click)="edit()"
        label="Edit"
        pButton
        icon="fa ui-icon-mode-edit"
        [disabled]="!selectedItem"
      ></button>

      <button
        type="button"
        class="btn-to-right"
        pButton
        icon="fa ui-icon-trash"
        [disabled]="!selectedItem || selectedItem.commsTemplates.length > 0"
        (click)="delete()"
        label="Delete"
      ></button>
    </div>
  </div>
</div>

<div class="card" *ngIf="showEditForm">
  <div class="ui-grid-row">
    <div class="ui-g-8">
      <h2>Event Details</h2>

      <form [formGroup]="formGroup">
        <input type="hidden" formControlName="id" id="id" />

        <div class="ui-grid-row">
          <div class="ui-g-3">
            <label for="commsEventCode">Event Code: </label>
          </div>

          <div class="ui-g-9">
            <input
              [readonly]="isEditMode()"
              pInputText
              id="commsEventCode"
              formControlName="commsEventCode"
              class="w-100"
            />
          </div>

          <div class="ui-g-3">
            <label for="title">Title: </label>
          </div>
          <div class="ui-g-9">
            <input pInputText id="title" formControlName="title" class="w-100" />
          </div>

          <div class="ui-g-3">
            <label for="description">Description: </label>
          </div>
          <div class="ui-g-9">
            <input pInputText id="description" formControlName="description" class="w-100" />
          </div>

          <div class="ui-g-3">Model:</div>
          <div class="ui-g-9">
            <p-dropdown
              name="mergeModel"
              [style]="{ width: '100%' }"
              filter="true"
              [options]="mergeModelChoices"
              id="mergeModel"
              formControlName="mergeModel"
            ></p-dropdown>
          </div>

          <!--

          <div class="ui-g-3">
            <label for="active">Active: </label>
          </div>
          <div class="ui-g-9">
            <input pInputText id="active" formControlName="active" class="w-100">
          </div>

          -->

          <div class="ui-g-12">
            <div class="text-right">
              <button
                pButton
                label="Save Changes"
                (click)="save()"
                [disabled]="!canSave()"
              ></button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
